import { useEffect, useState } from "react";
import axios from "axios";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const AboutInstitute = () => {
    const settings = {
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
    };

    const [about, setAbout] = useState([]);

    useEffect(() => {
        axios.get("/api/student/get-about-institute-details")
            .then(response => {
                setAbout(response.data);
            })
            .catch(error => {
                console.error("Error fetching about us:", error);
            });
    }, []);

    const fileUrl = `${process.env.REACT_APP_BASE_SITE_URL}/uploads/`;
    return (
        <div className="row gy-44">
            <div className="col-xxl-6">
                <div className="card p-0 overflow-hidden position-relative radius-12 h-100">
                    <div className="card-header py-16 px-10 bg-base border border-end-0 border-start-0 border-top-0">
                        <h3 className="mb-0">About Institute</h3>
                    </div>
                    <div className="card-body p-10 pt-10">

                        {about.length === 0 ? (
                            <div className="row gy-3 p-10">
                                <div className="text-center error">No About Institute Found</div>
                            </div>
                        ) : (
                            about.map((event, index) => {
                                const banners = event.images ? event.images.split(",") : [];
                                return (
                                    <div key={index}>
                                        <div className="banner-carousel" style={{ margin: '0 auto', maxWidth: '1200px' }}>
                                            {banners.length > 0 && (
                                                <Slider {...settings}>
                                                    {banners.map((banner) => (
                                                        <div key={banner.trim()}>
                                                            <img src={`${fileUrl}${banner.trim()}`} alt={banner.trim()} />
                                                        </div>
                                                    ))}
                                                </Slider>
                                            )}
                                        </div>
                                        
                                        <div className="row gy-3 p-10">
                                            <div dangerouslySetInnerHTML={{ __html: event.content }} />
                                        </div>
                                    </div>
                                );
                            })
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutInstitute;